export const ENABLE_GAS_ANALYTICS = true;